import React from 'react';
import PropTypes from 'prop-types';

import './index.less';

import Modal from '../';
import VideoPlayer from 'ck-core-client/source/ui/VideoPlayer';
import bowser from 'bowser';

const VideoModal = ({ onClose, videoId }) => (
	<Modal colour={'grey'} onClose={() => onClose()}>
		<div className="VideoModal">
			<VideoPlayer
				videoId={videoId}
				autoplay={true}
				fullscreen={false}
				hideFullScreenButton={!!bowser.ipad}
			/>
		</div>
	</Modal>
);

export default VideoModal;

VideoModal.propTypes = {
	videoId: PropTypes.string.isRequired,
	onClose: PropTypes.func.isRequired,
	colour: PropTypes.string,
	errorMessage: PropTypes.string
};
